import { VALID_PASSWORD, INVALID_PASSWORD } from '../actionTypes';
import { profileSecurityActions } from '../reducer';

const handleChangePassword = (event) => (dispatch) => {
    const password = event.target.value;

    if (password.length >= 8) {
        dispatch(profileSecurityActions[VALID_PASSWORD]());
    } else {
        dispatch(profileSecurityActions[INVALID_PASSWORD]());
    }
};

export default handleChangePassword;
